(function() {
  'use strict';
  angular.module('dso')
  .factory('dsoProviderService', ['$filter', 'DsoUsers', function($filter, DsoUsers) {
    var dsoProviderService = {
      getTaxIdLocations: getTaxIdLocations,
      resendRegistrationInvite: resendRegistrationInvite
    };

    function getTaxIdLocations(taxId) {
      return DsoUsers.getTaxIdLocations({id: taxId}).$promise;
    }

    function resendRegistrationInvite(user) {
      return DsoUsers.resendRegistrationInvite(user).$promise;
    }
    return dsoProviderService;
  }]);
})();
